<template>
  <div>
      <header id="header_area" class="header_area">
        <div id="mainNav" class="main_menu">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="container">
                    
                    <!-- Brand and toggle get grouped for better mobile display -->
                    <a class="navbar-brand logo_h" href="/"><img src="/img/logo.png" alt="Dlealp" /><img src="/img/logo-2.png" alt="Dlealp" /></a>
                    
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"> 
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    
                    <!-- Collect the nav links, forms, and other content for toggling -->
                    <div id="navbarSupportedContent" class="collapse navbar-collapse offset">
                        <ul class="nav navbar-nav menu_nav ml-auto">
                            <li class="nav-item"><a class="nav-link" href="/#dlealp_section_about">Conhe&ccedil;a a Dlealp</a></li>
                            <li class="nav-item"><a class="nav-link" href="/#dlealp_section_projects">Nosso trabalho</a></li>
                            <li class="nav-item"><a class="nav-link" href="/#dlealp_section_types">Modalidades</a></li>
                            <li class="nav-item"><a class="nav-link" href="/#dlealp_section_services">Servi&ccedil;os</a></li>
                            <li class="nav-item"><a class="nav-link" href="/galeria">Galeria</a></li>
                            <li class="nav-item"><a class="nav-link" href="/contato">Contatos</a></li>
                        </ul>
                    </div>

                </div>
            </nav>
        </div>
    </header>

  </div>
</template>

<script>

    export default {
        name: 'Header'
    } 
    
</script>

<style>

</style>